import {
    FETCH_PROFILE,
    FETCH_PROFILE_FAILURE,
    FETCH_PROFILE_SUCCESS,
} from 'store/actions/types';

export const fetchProfile = (payload) => {
    return {
        type: FETCH_PROFILE,
        payload: payload,
    };
};

export const fetchProfileFailure = (error) => {
    return {
        type: FETCH_PROFILE_FAILURE,
        error: error,
    };
};

export const fetchProfileSuccess = (response) => {
    return {
        type: FETCH_PROFILE_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/fetchProfile.js